import { Length, NullLength, NumberValue, pickNonEmpty, ValidatedArray } from '../../values/index.js';
export const Cell = ({ row, column } = {}) => {
    var _a, _b;
    return {
        row: (_a = NumberValue(row)) !== null && _a !== void 0 ? _a : 1,
        column: (_b = NumberValue(column)) !== null && _b !== void 0 ? _b : 1
    };
};
export const CellSpan = ({ from, to } = {}) => {
    return {
        from: Cell(from),
        to: to
            ? Cell(to)
            : {
                row: Cell(from).row + 1,
                column: Cell(from).column + 1
            }
    };
};
export const CellSize = ({ min, max } = {}) => {
    return {
        min: Length(min),
        max: NullLength(max) === null ? Length({ unit: 'fr', value: 1 }) : Length(max)
    };
};
export const Item = ({ from, to, order }) => {
    return {
        ...CellSpan({ from, to }),
        order: NumberValue(order)
    };
};
export const Row = ({ min, max }) => {
    return {
        min: Length(min),
        max: NullLength(max) === null ? null : Length(max)
    };
};
export const default12Columns = Array.from(Array(12)).map(() => CellSize({ min: null, max: null }));
export const default5Rows = [
    Row({ min: 36, max: 36 }),
    Row({ min: 36, max: 36 }),
    Row({ min: 36, max: 36 }),
    Row({ min: 36, max: 36 }),
    Row({ min: 36 })
];
export const Props = (props = {}) => {
    return {
        columns: [ValidatedArray(CellSize, props.columns), default12Columns].reduce(pickNonEmpty),
        rows: [ValidatedArray(Row, props.rows), default5Rows].reduce(pickNonEmpty),
        items: ValidatedArray(Item, props.items)
    };
};
export const validate = () => true;
export const fix = (props, styles) => props;
export const label = 'Grid';
export const type = 'grid';
export const property = 'gridIds';
export const category = 'aspect';
export const summarize = (props, styles, formId) => `${props.rows.length} / ${props.columns.length}`;
//# sourceMappingURL=grid.js.map